/**
 * WOM Configuration for Khushburat
 *
 * Client-specific configuration including:
 * - API endpoints
 * - Theme colors and styling
 * - Enabled widgets
 * - Custom behavior
 */

const vesselsWOMConfig = {
  name: "Khushburat",

  // API Configuration
  apiBaseUrl: "https://api.thewordofmouth.in",
  companyId: "khushburat",

  // Reviews API URL - will use product handle dynamically
  reviewsApiUrl: null, // Will be constructed dynamically based on product handle

  // Instagram API URL - will use product handle dynamically on product pages
  instagramApiUrl: null, // Will be constructed dynamically based on product handle

  // Use local JSON data instead of API (set to false to use API)
  useLocalData: false, // Using live API
  localDataUrl: "/assets/wom-product-data.json", // Path to local JSON file

  // Debug mode
  debug: true,

  // Theme Colors - Brown to match Add to Cart button
  colors: {
    primary: "#1a1a1a",
    accent: "#8B4F38",
    background: "#ffffff",
    text: "#374151",
    textLight: "#6b7280",
    border: "#e5e7eb",
    success: "#10b981",
    starColor: "#8B4F38",
  },

  // Typography
  fontFamily:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",

  // Spacing and Layout
  spacing: {
    cardRadius: "12px",
    cardPadding: "20px",
    gap: "16px",
  },

  // Widget Configuration - Enable/Disable widgets
  components: {
    socialProof: true,
    liveUsers: true,
    ratingBreakdown: true,
    reviews: true,
  },

  // Override to use company-wide data instead of product-specific
  useCompanyWideData: false,

  // Widget Settings
  settings: {
    liveUpdates: true,
    showVerifiedBadge: true,
    reviewsPerPage: 4,
  },

  // Custom Callbacks (Optional)
  onWriteReview: function () {
    console.log("Opening write review modal");
  },

  onLoadMore: function () {
    console.log("Loading more reviews");
  },
};

// Export for use
if (typeof module !== "undefined" && module.exports) {
  module.exports = vesselsWOMConfig;
} else {
  window.vesselsWOMConfig = vesselsWOMConfig;
  window.clientWOMConfig = vesselsWOMConfig;
}
